import {useEffect, useState} from "react";
import Loading from "../../../../component/Loading/Loading";
import {ExceptionPersonFormWithoutContainer} from "../../../../component/ExceptionPersonForm/ExceptionPersonForm";
import {SelectWithoutContainer} from "../../../../component/Select/Select";

const FilterOrders = ({searchParams, onSubmit}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [searchForm, setSearchForm] = useState({...searchParams});

    const defaultSearchParams = {
        exceptionPerson: {
            isAllCustomer: "TRUE",
            includeCustomerAreaBlock: [],
            excludeCustomerAreaBlock: [],
            includeCustomerTown: [],
            excludeCustomerTown: [],
            includeCustomerId: [],
            excludeCustomerId: [],
        },

        isVerified: true,
        isOpen: false,
        isExpired: false,

        isDelivered: false,
        isSend: false,
        isNotSend: false,

        sortBy: "DELIVERY_TIME" ,
    }
    const sortByOptions = [
        {
            label: "جدیدترین",
            value: "NEWEST"
        }, {
            label: "قدیمی ترین",
            value: "OLDEST"
        },{
            label: "ارزان ترین",
            value: "CHEAPEST"
        },
        {
            label: "گران ترین",
            value: "MOST_EXPENSIVE"
        },
        {
            label: "زمان تحویل",
            value: "DELIVERY_TIME"
        }
    ]
    const changeSearchForm = (key, value) => {
        const newSearchForm = {...searchForm, [key]: value};
        setSearchForm(newSearchForm);
    }

    useEffect(() => {
        (async () => {
            setIsLoading(false);
        })();
    }, []);


    if (isLoading)
        return <Loading/>


    return (
        <div className={"card"}>
            <div className="card-body">
                <label className="card-title text-center">فیلتر سفارشات</label>
                <div className="row">
                    <div className="col-md-3 mt-4">
                        <div className="col-12">
                            <ExceptionPersonFormWithoutContainer
                                exceptionPerson={searchForm.exceptionPerson != undefined ? JSON.parse(searchForm.exceptionPerson) : defaultSearchParams.exceptionPerson}
                                onChange={(value) => {
                                    changeSearchForm("exceptionPerson", JSON.stringify(value))
                                }}/>
                        </div>
                    </div>
                    <div className="col-md-3 mt-4">
                        <div className="mb-1">
                            <input className="form-check-input" type="checkbox" id="isVerified"
                                   checked={searchForm.isVerified != undefined ? JSON.parse(searchForm.isVerified) : defaultSearchParams.isVerified}
                                   onChange={() => {
                                       changeSearchForm("isVerified", searchForm.isVerified != undefined ? !JSON.parse(searchForm.isVerified) : !defaultSearchParams.isVerified)
                                   }}/>
                            <label className="form-check-label me-1" htmlFor="isVerified">
                                سفارشات تایید شده
                            </label>
                        </div>
                        <div className="mb-1">
                            <input className="form-check-input" type="checkbox" id="isOpen"
                                   checked={searchForm.isOpen != undefined ? JSON.parse(searchForm.isOpen) : defaultSearchParams.isOpen}
                                   onChange={() => {
                                       changeSearchForm("isOpen", searchForm.isOpen != undefined ? !JSON.parse(searchForm.isOpen) : !defaultSearchParams.isOpen)
                                   }}/>
                            <label className="form-check-label me-1" htmlFor="isOpen">
                                سفارشات باز
                            </label>
                        </div>
                        <div className="mb-1">
                            <input className="form-check-input" type="checkbox" id="isExpired"
                                   checked={searchForm.isExpired != undefined ? JSON.parse(searchForm.isExpired) : defaultSearchParams.isExpired}
                                   onChange={() => {
                                       changeSearchForm("isExpired", searchForm.isExpired != undefined ? !JSON.parse(searchForm.isExpired) : !defaultSearchParams.isExpired)
                                   }}/>
                            <label className="form-check-label me-1" htmlFor="isExpired">
                                سفارشات منقضی شده
                            </label>
                        </div>
                    </div>


                    <div className="col-md-3 mt-4">
                        <SelectWithoutContainer label={"مرتب سازی بر اساس"} options={sortByOptions}
                                                value={searchForm.sortBy || defaultSearchParams.sortBy}
                                                onChange={(value) => {
                                                    changeSearchForm("sortBy", value)
                                                }}/>
                    </div>
                </div>

            </div>


            <div className="col-12">
                <button className={"btn btn-primary w-100 mt-2"} onClick={() => {
                    onSubmit(searchForm)
                }}>جست و جو
                </button>
            </div>
        </div>
    );
}

export default FilterOrders;